// Angular
import { Component, OnInit, Inject, OnDestroy } from '@angular/core';

// Libraries
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngxs/store';

// Model
import { UserDashboardSettings } from '../../../../../channel/models/user-dashboard-settings.model';
import { AppCleanup } from '../../../../../../shared/models';

// Services
import { StorageActions } from '../../../../../../shared/state/storage.action';

@Component({
	selector: 'dashboard-setting-dialog',
	templateUrl: './dashboard-setting-dialog.component.html',
	styleUrls: ['./dashboard-setting-dialog.component.scss'],
})
export class DashboardSettingDialogComponent extends AppCleanup implements OnInit, OnDestroy {
	componentTitle: string = 'Dashboard Settings';
	useChannelColors: boolean;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: { userDashboardSettings: UserDashboardSettings },
		private dialogRef: MatDialogRef<DashboardSettingDialogComponent>,
		private store: Store
	) {
		super();
	}

	ngOnInit() {
		this.useChannelColors = this.data.userDashboardSettings.useChannelColors;
	}

	ngOnDestroy() {
		super.ngOnDestroy();
	}

	submit() {
		let userDashboardSettings = new UserDashboardSettings();
		userDashboardSettings.useChannelColors = this.useChannelColors;
		this.store.dispatch(new StorageActions.SetUserDashboardSettings(userDashboardSettings));
		this.dialogRef.close();
	}
}
